import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { FileUpload } from '@uhg-abyss/web/ui/FileUpload';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { Button } from '@uhg-abyss/web/ui/Button';
import { UploadComponent } from '../UploadComponent/UploadComponent';
import Navbar from '../Navbar/Navbar';
import FileData, { hasProcessedContent } from '../FileData/FileData';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import PageFooter from '../PageFooter/PageFooter';

export const AppBody = () => {
  const [loading, setLoading] = useState(false);
  const [file, setFile]= useState<any>(null)
  const [isEditing, setIsEditing] = useState(false)

  const onSubmitFile = (file) => {
    if (file){
      setFile(file)
      setLoading(true)
      setTimeout(() => {
        setLoading(false)
      }, 1500);
    }
  }
  const onClear = () => {
      setFile(null)
  }

  const isSplitView = !!file && (loading || hasProcessedContent(file));

  return (
    <div className="app-body">
      {/* <Navbar></Navbar> */}
      <section className="app-usage-guidelines" role="note" aria-labelledby="app-usage-guidelines-title">
        <div className="app-usage-guidelines-title" id="app-usage-guidelines-title">
          <span className="app-usage-guidelines-title-icon" aria-hidden="true">ℹ️</span>
          Usage Guidelines
        </div>
        <ul className="app-usage-guidelines-list">
          <li className="app-usage-guidelines-item">
            <span className="app-usage-guidelines-icon" aria-hidden="true">🌐</span>
            <span className="app-usage-guidelines-text">
              <strong>Language Support</strong>
              This solution is designed for English-language content. Non-English text may produce inaccurate or incomplete results.
            </span>
          </li>
          <li className="app-usage-guidelines-item">
            <span className="app-usage-guidelines-icon" aria-hidden="true">⏱</span>
            <span className="app-usage-guidelines-text">
              <strong>Processing time</strong>
              Typically 3–5 minutes. Larger documents may require additional time.
            </span>
          </li>
          <li className="app-usage-guidelines-item">
            <span className="app-usage-guidelines-icon" aria-hidden="true">📄</span>
            <span className="app-usage-guidelines-text">
              <strong>Upload limits</strong>
              Up to 10 files, file size 50 MB per file.
            </span>
          </li>
          <li className="app-usage-guidelines-item">
            <span className="app-usage-guidelines-icon" aria-hidden="true">📁</span>
            <span className="app-usage-guidelines-text">
              <strong>Supported formats</strong>
              PDF, DOC, DOCX, PNG, JPG, JPEG, GIF, JFIF
            </span>
          </li>
        </ul>
      </section>
      <div className={`app-workspace${isSplitView ? ' app-workspace-split' : ''}`}>
        <aside className="app-workspace-sidebar">
          <UploadComponent onSubmitFile={onSubmitFile} isFile={file} onClear={onClear} isEditing={isEditing} />
        </aside>
        {file && (
          <section className="app-workspace-main">
            {loading ? (
              <div className="loader-container">
                <LoadingSpinner
                  size="lg"
                  isLoading={loading}
                  ariaLoadingLabel="Retreiving Data"
                />
              </div>
            ) : (
              <FileData file={file} onEditChange={setIsEditing} requestId={file?.requestId} />
            )}
          </section>
        )}
      </div>
      <PageFooter />
    </div>
  );
};
